import O1HD from "../../../../engines/gameEngine";
import LotteryFFCManager from "./LotteryFFCManager";

const {ccclass, property} = cc._decorator;
/**
 * 分分彩Item
 */
@ccclass
export default class LotteryFFCItem extends cc.Component {

    @property({type:cc.Sprite,displayName:"奖品图片"})
    prizeIcon : cc.Sprite = null;
    @property({type:cc.Label,displayName:"已经下注的金额"})
    lbHasBetCount: cc.Label = null;

    private mZodiac : string;//当前生肖
    private lastLotteryCount : number;//上一次开奖的期数
    private mLotteryFFCManager : LotteryFFCManager;
    onLoad () {
        O1HD.on("LotteryFFCItem.reset" , this.reset , this );
    }

    start () {

    }

    bindData( zodiac : string ,lotteryFFCManager : LotteryFFCManager){
        this.mZodiac = zodiac;
        this.mLotteryFFCManager = lotteryFFCManager;
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/chineseZodiac/${this.mZodiac}`,cc.SpriteFrame,(error,assets:cc.SpriteFrame)=>{
            if ( error ) {
                console.log(`分分彩加载图片出错${this.mZodiac}`);
                return;
            }
            this.prizeIcon.spriteFrame = assets;
        });
    }

    /**
     * 下注
     */
    onBtnBet( e ){
        
    }

    /**
     * 重置
     */
    reset(){
        this.lbHasBetCount.string = `0`;
    }

}
